import Container from "@client/content/Containers/container";
import GridList, { type GridListComponentMapProps } from "@client/content/controls/GridList/component";
import { getContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { useUpdated } from "@common/lib/hooks";
import * as React from "react";
import { type BlogListItemContainerProps } from "./Item/container";
import "./style.less";

export type MapProps = RootContainerProps & {
  hasPosts: boolean;
  gridProps: GridListComponentMapProps<BlogListItemContainerProps>;

  categories: string[];
  pageSize: number;
};
export interface ActionProps {
  loadPage: (page: number) => void;
}

export default ({ gridProps, ...props }: ActionProps & MapProps) => {
  useUpdated(() => {
    props.loadPage(1);
  }, [props.categories, props.pageSize, props.loadPage]);

  return (
    <Container className={"wsc_content_blog_list"} {...getContainerProps(props)}>
      {props.hasPosts ? <GridList {...gridProps} load={props.loadPage} /> : <div>You currently have no posts</div>}
    </Container>
  );
};
